import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _slicedToArray } from '../../unsorted/slicedToArray.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { ClassNames } from '@emotion/react';
import { AnimatePresence } from 'framer-motion';
import { useMemo, useState, useRef, useCallback } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { TEXT_INPUT_SIZES, DEFAULT_TEXT_INPUT_SIZE, DEFAULT_TEXT_INPUT_ALIGN } from '../../constants.js';
import { getStartingSize } from '../../utils/styleHelpers.js';
import { a as adornmentSx, i as inputIconBaseSx, r as renderResponsiveContainerStyles, b as renderContainerStyles, c as inputContainerBaseSx, d as renderResponsiveInputSx, e as renderInputSx, f as baseInputSx, g as clearValueButtonSx, s as sideContainerSx, l as leftContainerSx, h as rightButtonsContainerSx } from '../styles/styles2.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { B as Body } from '../Body/Body.js';
import { a as Button } from '../ButtCon/ButtCon.js';
import { F as FramedImage } from '../FramedImage/FramedImage.js';
import { useTheme } from '../../hooks/useTheme.js';
import { i as isImageResizerProps } from '../../utils/imageHelpers2.js';
import { I as Icon } from '../Icon/Icon.js';
import { S as StatefulButtCon } from '../StatefulButtCon/StatefulButtCon.js';
import { S as Stack } from '../Stack/Stack.js';
import { S as SmartClone } from '../SmartClone/SmartClone.js';
import { useForwardLocalDomRef } from '../../hooks/useForwardLocalDomRef.js';
import { useGetSubcomponentChild } from '../../hooks/useGetSubcompnentChild.js';
import { useSplitApartChildrenAndSubComponents } from '../../hooks/useSplitApartChildrenAndSubComponents.js';
import { useResizeObserver } from '../../hooks/useResizeObserver.js';
import { useConvertSxToEmotionStyles } from '../../hooks/useConvertSxToEmotionStyles.js';
import { C as ClearFieldButton } from '../ClearFieldButton/ClearFieldButton.js';

var _excluded$5 = ["children", "sx"];
function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInputAdornment(_ref) {
  var children = _ref.children,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var allStyles = merge(adornmentSx, sx);
  return jsx(Body, _objectSpread$5(_objectSpread$5({}, props), {}, {
    sx: allStyles,
    children: children
  }));
}
TextInputAdornment.displayName = "TextInput.Adornment";

var _excluded$4 = ["children", "currentInputValue", "sx"];
function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInputButton(_ref) {
  var children = _ref.children;
    _ref.currentInputValue;
    var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded$4);
  return jsx(Button, _objectSpread$4(_objectSpread$4({}, props), {}, {
    variant: "tertiary",
    size: "small",
    sx: sx,
    children: children
  }));
}
TextInputButton.displayName = "TextInput.Button";
TextInputButton.Icon = Button.Icon;
TextInputButton.Logo = Button.Logo;

var _excluded$3 = ["sx", "use"];
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInputFramedImage(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    use = _ref.use,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var _useTheme = useTheme(),
    base = _useTheme.base;
  var allStyles = merge({
    w: "base.icon.size.300",
    h: "auto"
  }, sx);
  var shouldUseImageResizer = isImageResizerProps(use);
  var typedProps = useMemo(function () {
    return shouldUseImageResizer ? _objectSpread$3(_objectSpread$3({}, props), {}, {
      relativeImageSizeInLayout: base.icon.size[300]
    }) : _objectSpread$3(_objectSpread$3({}, props), {}, {
      use: use
    });
  }, [use, props, shouldUseImageResizer, base.icon.size]);
  return jsx(FramedImage, _objectSpread$3(_objectSpread$3({}, typedProps), {}, {
    sx: allStyles,
    use: use
  }));
}
TextInputFramedImage.displayName = "TextInput.FramedImage";

var _excluded$2 = ["sx"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInputIcon(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var allStyles = merge(inputIconBaseSx, sx);
  return jsx(Icon, _objectSpread$2(_objectSpread$2({}, props), {}, {
    sx: allStyles
  }));
}
TextInputIcon.displayName = "TextInput.Icon";

var _excluded$1 = ["children", "currentInputValue", "sx"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInputStatefulButtCon(_ref) {
  var children = _ref.children;
    _ref.currentInputValue;
    var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return jsx(StatefulButtCon, _objectSpread$1(_objectSpread$1({}, props), {}, {
    size: "small",
    sx: sx,
    children: children
  }));
}
TextInputStatefulButtCon.displayName = "TextInput.StatefulButtCon";
TextInputStatefulButtCon.SvgIcon = StatefulButtCon.SvgIcon;

var _excluded = ["domRef", "inputRef", "rc", "placeholder", "sx", "testId", "name", "id", "children", "className", "validationStatus", "onChange", "onClearValue", "value", "hideClearValueButton", "textAlign", "defaultValue", "sizeVariant", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInput(_ref) {
  var domRef = _ref.domRef,
    _ref$inputRef = _ref.inputRef,
    inputRef = _ref$inputRef === void 0 ? {
      current: null
    } : _ref$inputRef,
    rc = _ref.rc,
    placeholder = _ref.placeholder,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "TextInput" : _ref$testId,
    name = _ref.name,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? name : _ref$id,
    children = _ref.children,
    className = _ref.className,
    validationStatus = _ref.validationStatus,
    onChange = _ref.onChange,
    onClearValue = _ref.onClearValue,
    value = _ref.value,
    hideClearValueButton = _ref.hideClearValueButton,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? DEFAULT_TEXT_INPUT_ALIGN : _ref$textAlign,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
    _ref$sizeVariant = _ref.sizeVariant,
    sizeVariant = _ref$sizeVariant === void 0 ? DEFAULT_TEXT_INPUT_SIZE : _ref$sizeVariant,
    disabled = _ref.disabled,
    inputDomAttributes = _objectWithoutProperties(_ref, _excluded);
  var localInputRef = useForwardLocalDomRef(inputRef);
  var _useState = useState(typeof value === "number" ? value.toString() : typeof value === "string" ? value : defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledValue = _useState2[0],
    setUncontrolledValue = _useState2[1];
  var button = useGetSubcomponentChild(children, TextInputButton);
  var buttCon = useGetSubcomponentChild(children, TextInputStatefulButtCon);
  var icon = useGetSubcomponentChild(children, TextInputIcon);
  var framedImage = useGetSubcomponentChild(children, TextInputFramedImage);
  var adornment = useGetSubcomponentChild(children, TextInputAdornment);
  var _useSplitApartChildre = useSplitApartChildrenAndSubComponents(children, [TextInputButton, TextInputStatefulButtCon, TextInputIcon, TextInputFramedImage, TextInputAdornment]),
    otherChildren = _useSplitApartChildre.otherChildren;
  var rightHandButtonsContainerRef = useRef(null);
  var leftHandButtonsContainerRef = useRef(null);
  var _useResizeObserver = useResizeObserver(rightHandButtonsContainerRef, 30),
    rightHandButtonsContainerWidth = _useResizeObserver.width;
  var _useResizeObserver2 = useResizeObserver(leftHandButtonsContainerRef, 30),
    leftHandButtonsContainerWidth = _useResizeObserver2.width;
  var onClearInputText = useCallback(function () {
    // @NOTE: if its a CONTROLLED input, simply call the
    // onClearValue prop, and then early exit
    if (value !== undefined) {
      return onClearValue === null || onClearValue === void 0 ? void 0 : onClearValue();
    }

    // @NOTE: input is UNCONTROLLED, so we need to manually
    // update it's value:
    if (localInputRef.current) {
      localInputRef.current.value = "";
      localInputRef.current.focus();
    }
    onChange === null || onChange === void 0 ? void 0 : onChange({
      type: "change",
      target: localInputRef === null || localInputRef === void 0 ? void 0 : localInputRef.current
    });
    setUncontrolledValue("");
    onClearValue === null || onClearValue === void 0 ? void 0 : onClearValue();
    return false;
  }, [localInputRef, onChange, value, onClearValue]);
  var handleInputChange = useCallback(function (event) {
    if (value === undefined) setUncontrolledValue(event.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  }, [onChange, value]);
  var theme = useTheme();
  var defaultSize = getStartingSize(sizeVariant, DEFAULT_TEXT_INPUT_SIZE, TEXT_INPUT_SIZES);
  var allContainerStyles = useMemo(function () {
    return merge(inputContainerBaseSx, renderContainerStyles({
      size: defaultSize,
      theme: theme
    }), renderResponsiveContainerStyles({
      size: sizeVariant,
      theme: theme
    }), sx);
  }, [defaultSize, sizeVariant, sx, theme]);
  var valueToUse = value !== null && value !== void 0 ? value : uncontrolledValue;
  var allInputSx = useMemo(function () {
    return merge(baseInputSx, renderInputSx({
      theme: theme,
      validationStatus: validationStatus,
      leftHandButtonsWidth: leftHandButtonsContainerWidth,
      rightHandButtonsWidth: rightHandButtonsContainerWidth,
      textAlign: textAlign,
      hasValue: Boolean(valueToUse)
    }), renderResponsiveInputSx({
      theme: theme,
      validationStatus: validationStatus,
      size: sizeVariant,
      leftHandButtonsWidth: leftHandButtonsContainerWidth,
      rightHandButtonsWidth: rightHandButtonsContainerWidth,
      textAlign: textAlign,
      hasValue: Boolean(valueToUse)
    }));
  }, [leftHandButtonsContainerWidth, rightHandButtonsContainerWidth, sizeVariant, textAlign, theme, validationStatus, valueToUse]);
  var convertedInputStyles = useConvertSxToEmotionStyles(allInputSx);
  var hasLeftHandItems = framedImage || icon || textAlign === "left" && Boolean(adornment);
  return jsx(ClassNames, {
    children: function children(_ref2) {
      var _adornment$props, _adornment$props2, _button$props$testId, _buttCon$props$testId;
      var cx = _ref2.cx;
      return jsxs(Stack, {
        rc: rc,
        domRef: domRef,
        className: cx("".concat(className !== null && className !== void 0 ? className : "", " TextInput"), {
          "TextInput--disabled": disabled
        }),
        testId: testId,
        sx: allContainerStyles,
        "data-validation-status": validationStatus,
        children: [jsx("input", _objectSpread(_objectSpread({}, inputDomAttributes), {}, {
          disabled: disabled,
          name: name,
          ref: localInputRef,
          "data-testid": "".concat(testId, "__input"),
          onChange: handleInputChange,
          value: valueToUse,
          id: id,
          placeholder: placeholder,
          css: convertedInputStyles,
          className: "TextInput__input"
        })), hasLeftHandItems && jsxs(Stack, {
          direction: "row",
          alignItems: "center",
          sx: merge(leftContainerSx, sideContainerSx),
          domRef: leftHandButtonsContainerRef,
          className: "leftContainer",
          children: [framedImage || icon || null, textAlign === "left" && adornment ? jsx(SmartClone, {
            testId: (adornment === null || adornment === void 0 || (_adornment$props = adornment.props) === null || _adornment$props === void 0 ? void 0 : _adornment$props.testId) || "".concat(testId, "__adornment"),
            children: adornment
          }) : null]
        }), jsxs(Stack, {
          alignItems: "center",
          direction: "row",
          sx: merge(rightButtonsContainerSx, sideContainerSx),
          testId: "".concat(testId, "__rightButtonsContainer"),
          domRef: rightHandButtonsContainerRef,
          className: "rightButtonsContainer",
          children: [textAlign === "right" && Boolean(adornment) ? jsx(SmartClone, {
            testId: (adornment === null || adornment === void 0 || (_adornment$props2 = adornment.props) === null || _adornment$props2 === void 0 ? void 0 : _adornment$props2.testId) || "".concat(testId, "__adornment"),
            children: adornment
          }) : null, jsx(AnimatePresence, {
            children: valueToUse && !hideClearValueButton && jsx(ClearFieldButton, {
              testId: "".concat(testId, "__rightButtonsContainer__clearValueButton"),
              sx: clearValueButtonSx,
              onClick: onClearInputText,
              disabled: disabled
            })
          }), button && jsx(SmartClone, {
            disabled: disabled,
            currentInputValue: valueToUse,
            testId: (_button$props$testId = button.props.testId) !== null && _button$props$testId !== void 0 ? _button$props$testId : "".concat(testId, "__rightButtonsContainer__rightButton"),
            children: button
          }), buttCon && jsx(SmartClone, {
            disabled: disabled,
            currentInputValue: valueToUse,
            testId: (_buttCon$props$testId = buttCon.props.testId) !== null && _buttCon$props$testId !== void 0 ? _buttCon$props$testId : "".concat(testId, "__rightButtonsContainer__rightButtCon"),
            children: buttCon
          })]
        }), otherChildren]
      });
    }
  });
}
TextInput.displayName = "TextInput";
TextInput.Button = TextInputButton;
TextInput.Icon = TextInputIcon;
TextInput.FramedImage = TextInputFramedImage;
TextInput.StatefulButtCon = TextInputStatefulButtCon;
TextInput.Adornment = TextInputAdornment;

export { TextInput as T, TextInputIcon as a };
//# sourceMappingURL=TextInput.js.map
